export class Message {

  public static messageReussite = 'SUCCESS';
  public static messageEchec = 'FAILED';
  public static messageAttente = 'PENDING';
  public static messageCreditInsuffisant = 'INSUFFISANT CREDIT';
  public static messageNumIncorrect = 'INVALID DESTINATION';
  public static messageTimeout = 'TIMEOUT';
  public static messageAnnuler = 'CANCEL';


}
